import PropTypes from "prop-types";
import React, {
	Component
} from "react";
import xtend from "xtend";

import InputLabel from "../Layout/InputLabel";
import InputContainer from "../Layout/InputContainer";
import inputStyle from "../Layout/intputStyle";
import ErrorMessage from "../Layout/ErrorMessage";
import { predictSelectionType } from "./lib";

import { useResources } from "@aetonix/hooks";
import { useSources } from "../../Context/useSources";

class PickerWebComp extends Component {
	constructor(props){
		super(props);

		this.state = {
			newValue: null
		};

		this.handleChange = handleChange.bind(this);
	}

	render(){
		const props = this.props;
		const localize = this.props.localize;
		const localizeFrom = this.props.localizeFrom;
		const errors = this.props.errors;
		const schema = this.props.schema;
		let fallbackPhrase = this.props.fallbackPhrase;
		const filtered = this.props.filterList ?? [];
		let enumLabel = schema.enumLabel;
		let options = schema.enum || [];
		const source = schema.source;
		if (source && props.externalSources && props.externalSources[schema.source]){
			const schemaSource = props.externalSources[schema.source].filter(({value})=> filtered.indexOf(value) < 0);
			options = schemaSource.map(function(name){
				return name.value;
			});
			enumLabel = schemaSource.map(function(name){
				return name.label;
			});
		}

		const sources = schema.sources;
		if(sources && props.externalSources){
			let schemaSources = [];
			sources.forEach(e => {
				schemaSources = schemaSources.concat(props.externalSources[e] || []);
			});
			schemaSources = removeDuplicates(schemaSources).filter(({value})=> filtered.indexOf(value) < 0);
			options = schemaSources.map(name => name.value);
			enumLabel = schemaSources.map(name => name.label);
		}

		const newValue = this.state.newValue;
		const defaultValue = (this.props.defaultValue === undefined || this.props.defaultValue === null) ? newValue : this.props.defaultValue;

		const value_description = schema.value_description;
		const localizationMap = schema.value_localization || schema.valueLocalization;

		const selectOptions = options.map(function(option, index){
			let localized = "";
			if(enumLabel && enumLabel[index]){
				const label = enumLabel[index];
				if(typeof label === "object"){
					localized = localizeFrom(label, ".");
				} else {
					localized = localize(label) || label;
				}
			} else if(localizationMap){
				localized = localizeFrom(localizationMap, option);
			} else if(value_description) {
				localized = localize(value_description + "." + option);
			}

			if(!localized)
				localized = option;

			return (
				<option value={option} key={option}>{localized}</option>
			);
		});

		const renderValue = newValue === null ? defaultValue : newValue;

		let selectStyle = xtend(inputStyle.raw, {
			width: "100%"
		});

		if(errors && errors.length)
			selectStyle = xtend(selectStyle, inputStyle.errored);

		const prompt = localize("form.prompt");
		let defaultExists = null;

		let labelText;
		if(schema !== undefined && schema.localization){
			labelText = localizeFrom(schema.localization, ".");
		} else if(schema !== undefined && schema.description) {
			labelText = localize(schema.description);
		} else {
			labelText = "Select from Options";
		}

		if (!options.includes(defaultValue)) {
			fallbackPhrase = fallbackPhrase || predictSelectionType(source, sources);
			if (typeof fallbackPhrase === "object") {
				fallbackPhrase = localizeFrom(fallbackPhrase, ".");
			} else {
				fallbackPhrase = localize(fallbackPhrase);
			}
			const defaultOptionText = `${fallbackPhrase} (${defaultValue})`;
			defaultExists = (<option value={defaultValue}>{defaultOptionText}</option>);
		}

		if (defaultValue === undefined || defaultValue === null || defaultValue.length === 0)
			defaultExists = (<option value={undefined}>{prompt}</option>);

		return (
			<InputContainer inline={this.props.inline}>
				<ErrorMessage id={this.props.id + "_error"} errors={errors} schema={schema} />
				<InputLabel schema={schema} labelStyle={this.props.labelStyle} />
				<select id={this.props.id} value={renderValue}
					style={selectStyle}
					aria-label={labelText || "Select from Options"}
					onChange={this.handleChange}>
					{defaultExists}
					{selectOptions}
				</select>
			</InputContainer>
		);
	}
}

import types from "../Layout/inputTypes";
PickerWeb.propTypes = types;

function handleChange(event) {
	let value = event.target.value;
	const onChange = this.props.onChange;

	const schema = this.props.schema;
	if(schema.type === "number")
		value = parseInt(value, 10);

	if(onChange) onChange(value);
	this.setState({
		newValue: value
	});
}

function removeDuplicates(list){
	const mapped = list.reduce((r, e) => {
		r[e.value] = e;
		return r;
	}, {});
	return Object.keys(mapped).map(k => mapped[k]);
}

export default function PickerWeb(props){
	const { localize, localizeFrom } = useResources();
	const sources = useSources();
	return (
		<PickerWebComp {...props} localize={localize} localizeFrom={localizeFrom} externalSources={sources} />
	);
}